import { Helmet } from "react-helmet-async";

import { usePublicConfig } from "@/lib/usePublicConfig";
import { SEO_DEFAULTS } from "@/lib/seoDefaults";

/**
 * Renders the <title> + <meta name="description"> for a static marketing route.
 *
 * Resolution order per field: admin override (from /public-config → cfg.seo[path])
 * → the `title`/`description` props → the built-in default in seoDefaults.js.
 *
 * Exactly one <Helmet> is rendered so prerendered snapshots carry a single title
 * and description. The admin can edit these live under /admin/seo.
 */
export default function Seo({ path, title, description }) {
  const cfg = usePublicConfig();
  const override = (cfg?.seo && cfg.seo[path]) || {};
  const def = SEO_DEFAULTS[path] || {};

  const finalTitle = override.title || title || def.title;
  const finalDescription = override.description || description || def.description;

  return (
    <Helmet>
      {finalTitle ? <title>{finalTitle}</title> : null}
      {finalDescription ? (
        <meta name="description" content={finalDescription} />
      ) : null}
    </Helmet>
  );
}
